// DiaCalendario.jsx
import { useDroppable } from '@dnd-kit/core';

export const DiaCalendario = ({ id, children, dia }) => {
	const { setNodeRef, isOver } = useDroppable({ id });
	console.log(children.props.children.tarea);
	
	return (
		<div
			ref={setNodeRef}
			style={{
				width: '100%',
				height: children ? '100%' : undefined,        // solo usa 100% si hay children
				minHeight: children.props.children.tarea  ? undefined : '15vh',     // fuerza un tamaño mínimo si está vacío
				padding: children ? 4 : 12,                   // más padding cuando está vacío
				borderRadius: 4,
				backgroundColor: isOver ? 'var(--fondo2)' : '#f5f5f5',
				overflow: 'visible',
				position: 'relative',
				transition: 'all 0.2s ease-in-out',
			}}
		>
			{dia}
			

			{children}
		</div>


	);
};
